import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { ArtikelDetail } from './artikelDetail';
// eslint-disable-next-line import/no-cycle
import { ArtikelDetailLieferant } from './artikelDetailLieferant';

export interface RechnungPosition {
    rNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posAMenge: number;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    lkz: number;
    pd: number;
    pz: number;
    lNr: number;

    updDat?: string;
    updUhr?: number;
    updUser?: string;

    artikelDetail?: ArtikelDetail;
    hauptlieferant?: ArtikelDetailLieferant;
}

export interface RechnungPositionFilter {
    rNrList?: string[];
    kNr?: number;
    rNr?: string;
    pos?: number;

    withArtikelDetail?: boolean;
    withHauptlieferant?: boolean;
}

export const defaultRechnungPosition: RechnungPosition = {
    rNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posAMenge: 0,
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    lkz: 0,
    pd: 0,
    pz: 0,
    lNr: 0,
};

export function useRechnungPositionList(
    filter: RechnungPositionFilter,
    apiOptions?: UseApiOptions<RechnungPosition[]>,
): QueryResult<RechnungPosition[]> {
    return useApi<RechnungPosition[]>(Controller.rechnungPosition + '/list', { filter }, apiOptions);
}

interface AddRechnungPositionResult {
    newNr: number;
}

export async function addRechnungPosition(rechnungPosition: RechnungPosition): Promise<AddRechnungPositionResult> {
    return callApi<AddRechnungPositionResult>(Controller.rechnungPosition + '/add', { rechnungPosition });
}

export async function updateRechnungPosition(rechnungPosition: RechnungPosition): Promise<void> {
    return callApi<void>(Controller.rechnungPosition + '/update', { rechnungPosition });
}

export async function deleteRechnungPosition(rechnungPosition: RechnungPosition): Promise<void> {
    return callApi<void>(Controller.rechnungPosition + '/delete', { rechnungPosition });
}

export async function moveUpRechnungPosition(rNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.rechnungPosition + '/moveup', {
        rechnungPosition: {
            rNr,
            pos,
        },
    });
}
